import React, { FC } from 'react';
import { PostDetail } from 'types/PostDetail';
import { TYPE } from '@kontentino/kontentino-constants/Pages';
import { STATUS } from '@kontentino/kontentino-constants/Posts';
import { Alert } from '@kontentino/ui';
import { openBlank } from 'utils/url';
import { IGPostPublishingMethodUtils } from 'app/modules/posts/modules/post/constants/instagramPublishingMethodsProperties';
import { PseudoPostTypesUtils } from 'app/modules/posts/utils/pseudoPostType';
import { PseudoPostType } from 'constants/post';
import { useTranslation } from 'react-i18next';

type Props = {
  postDetail?: PostDetail;
};

const PostDetailPublishingMethod: FC<Props> = ({ postDetail }) => {
  const { t } = useTranslation();
  if (
    typeof postDetail?.status === 'number' &&
    ([STATUS.POSTED, STATUS.SCHEDULED] as number[]).includes(postDetail.status)
  ) {
    return null;
  }

  if (
    postDetail &&
    postDetail.page.type === TYPE.INSTAGRAM &&
    postDetail.attachments?.publishingMethod
  ) {
    const { link, label, description } =
      IGPostPublishingMethodUtils.getProperties(
        postDetail.attachments.publishingMethod,
        PseudoPostTypesUtils.findOptionByCombination({
          type: postDetail.type,
          subtype: postDetail.subtype,
          pageType: postDetail.page.type,
          attachments: postDetail.attachments,
        })?.key ?? PseudoPostType.Unknown,
      );

    return (
      <Alert
        data-name="posts-preview_publishing-method"
        data-value={postDetail.attachments?.publishingMethod}
        title={label}
        children={description}
        cta={
          typeof link === 'string'
            ? {
                label: t('learnMore'),
                onClick: () => openBlank(link),
              }
            : undefined
        }
      />
    );
  }

  return null;
};

export default PostDetailPublishingMethod;
